import { inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { INTENDED_URL } from '../auth.data';

export const AuthenticationGuard = async (_route: unknown, state: RouterStateSnapshot) => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const isLoggedIn: boolean = authenticationService.isAuthenticatedQuickCheck();

  if (isLoggedIn) {
    return true;
  }

  sessionStorage.clear();
  localStorage.clear();

  const currentUrl = state.url;
  if (currentUrl) {
    sessionStorage.setItem(INTENDED_URL, currentUrl);
  }

  return router.createUrlTree(['/welcome']);
};
